import {gql} from "@irati/utils/gql"

export const rawQuery = gql`
  fragment DealStockCountById on Query {
    dealStockCount(dealId: $dealId) {
      allOutOfStock
      stockTotals {
        id
        count
      }
    }
  }
`

const query = gql`
  query DealStockCountById($dealId: ID) {
    ...DealStockCountById
  }
  ${rawQuery}
`

export const toString = query.loc.source.body

export default query
